export default __webpack_public_path__ + "07e0ed52e36350f5056b92fc768e64c6.png";